import { login } from 'services/api/common/auth/login';
import { logout } from 'services/api/common/auth/logout';
import { refreshToken } from 'services/api/common/auth/refreshToken';

export const commonApi = {
  login,
  logout,
  refreshToken,
};
